import {
  isRNWebview,
  IS_RN_WEBVIEW_ANDROID,
  IS_RN_WEBVIEW_IOS,
  VALUELEAF_PIXEL_BASE_URL,
  DEFAULT_REFERRAL_CODE,
  REFCODE_TRACKIER_ANALYTICS,
} from 'constants/constants';
import { ANALYTICS_DEVICE_OS_TYPE, STORAGE_KEYS } from 'constants/enums';
import {
  getMobileOperatingSystem,
  dispatchGTMEvent,
  isAndroidDevice,
  isIOSDevice,
  isMobileDeviceOnly,
} from 'helpers/utils';
import IUser from 'types/IUser';

import { getSHA256HexString } from './crypto';
import { addLogsToSentry } from './sentry';

const UTM_SOURCES = {
  IOS_APP: 'iOS_app',
  IOS_BROWSER: 'iOS_browser',
  ANDROID_APP: 'android_app',
  ANDROID_BROWSER: 'android_browser',
  DESKTOP_BROWSER: 'desktop_browser',
};

const getUTMSource = () => {
  if (IS_RN_WEBVIEW_IOS) return UTM_SOURCES.IOS_APP;
  if (IS_RN_WEBVIEW_ANDROID) return UTM_SOURCES.ANDROID_APP;
  if (isAndroidDevice()) return UTM_SOURCES.ANDROID_BROWSER;
  if (isIOSDevice()) return UTM_SOURCES.IOS_BROWSER;
  return UTM_SOURCES.DESKTOP_BROWSER;
};

const dispatchFTDMarketingEvents = () => {
  const utmParams = JSON.parse(localStorage.getItem(STORAGE_KEYS.UTM_PARAMETERS) || '{}');
  const clickId = utmParams?.click_id;

  if (clickId) {
    fetch(`${VALUELEAF_PIXEL_BASE_URL}?linkid=${clickId}&goal_name=Deposit_success`);
  }
};

const dispatchGtmSignupEvent = async (
  userId: IUser['id'],
  referralCode?: string,
  email?: string
) => {
  let sha256EmailHex: string | null = null;

  try {
    if (email) sha256EmailHex = await getSHA256HexString(email);
  } catch (error) {
    addLogsToSentry({ userId }, error);
  } finally {
    dispatchGTMEvent('delta_signup_successful', {
      userId,
      referralCode,
      userEmailSha256: sha256EmailHex,
    });
  }
};

// currently logic  being used for trackier and appsflyer
const checkRefCodeValidForSendingAttributionData = (
  userReferralCode?: string | null,
  refcodeForAnalytics: string = DEFAULT_REFERRAL_CODE
) => {
  return (
    !userReferralCode ||
    userReferralCode.toLowerCase() === refcodeForAnalytics.toLowerCase()
  );
};

const getTrackierClickId = (referralCode?: string) => {
  if (
    checkRefCodeValidForSendingAttributionData(referralCode, REFCODE_TRACKIER_ANALYTICS)
  ) {
    const trackierClickId = localStorage.getItem(STORAGE_KEYS.TRACKIER_CLICK_ID);
    return trackierClickId || undefined;
  }

  return undefined;
};

const removeTrackierClickId = () => {
  localStorage.removeItem(STORAGE_KEYS.TRACKIER_CLICK_ID);
};

// gives from where user is signing up or loggin in
const getDeviceOSTypeForAnalytics = (): ANALYTICS_DEVICE_OS_TYPE => {
  const osType = getMobileOperatingSystem();

  if (isRNWebview()) {
    return osType;
  }

  if (isMobileDeviceOnly()) {
    return `${osType}_web` as ANALYTICS_DEVICE_OS_TYPE;
  }

  return ANALYTICS_DEVICE_OS_TYPE.WEB;
};

export {
  getUTMSource,
  dispatchFTDMarketingEvents,
  dispatchGtmSignupEvent,
  getTrackierClickId,
  removeTrackierClickId,
  getDeviceOSTypeForAnalytics,
  checkRefCodeValidForSendingAttributionData,
};
